module.exports = __webpack_public_path__ + "media/סרטן.423e55e3.mp3";